import { defineStore } from "pinia";
import { reactive, ref } from "vue";
export const useNavigationAlertStore = defineStore("navigationAlertStore", () => {
  const currentAlert = ref(null);
  const to = reactive({});
  const from = reactive({});
  function setAlert(alert, toRoute, fromRoute) {
    currentAlert.value = alert;
    to.value = toRoute;
    from.value = fromRoute;
  }
  function clearAlert() {
    currentAlert.value = null;
    to.value = {};
    from.value = {};
  }
  return {
    // State
    currentAlert,
    to,
    from,
    // Getters
    // Actions
    setAlert,
    clearAlert
  };
});
